function getPathByStepIndex(steps, currentStepIndex) {
  return steps[currentStepIndex]?.path
}

export default getPathByStepIndex
